module.exports = __webpack_public_path__ + "img/info2.ac841d25.svg";